"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UplinkPayloadAttributeMetaTypes = void 0;
/**
 * @enum UplinkPayloadAttributeMetaTypes
 * Classifies attributes in the payload instance by the intended use / meaning type. Used where system needs to route parts of uplink differently.
 */
var UplinkPayloadAttributeMetaTypes;
(function (UplinkPayloadAttributeMetaTypes) {
    /** A confirmation from the device about its configurable settings */
    UplinkPayloadAttributeMetaTypes["DEVICE_CONFIG"] = "DEVICE_CONFIG";
    /** A value relating to some diagnostic measure, in diagnostic mode */
    UplinkPayloadAttributeMetaTypes["DEVICE_DIAGNOSTIC"] = "DEVICE_DIAGNOSTIC";
    /** An error report relating to the device, e.g.: `batteryErr` or `linkCheckErr` */
    UplinkPayloadAttributeMetaTypes["DEVICE_ERROR"] = "DEVICE_ERROR";
    /** A value relating to some monitored aspect of the entity that the device is attached to */
    UplinkPayloadAttributeMetaTypes["DEVICE_MEASUREMENT"] = "DEVICE_MEASUREMENT";
    /** Some data about the device itself, e.g.: `deviceEUI`, `firmwareVersion`, `messageType`, or `batteryVoltage` */
    UplinkPayloadAttributeMetaTypes["DEVICE_META_DATA"] = "DEVICE_META_DATA";
    /** A report about the device status, e.g.: `reboot`, `charging`, or `gpsFix` */
    UplinkPayloadAttributeMetaTypes["DEVICE_STATUS"] = "DEVICE_STATUS";
})(UplinkPayloadAttributeMetaTypes || (exports.UplinkPayloadAttributeMetaTypes = UplinkPayloadAttributeMetaTypes = {}));
